import React from 'react';
import ProjectCard from '../components/ProjectCard';
import { PROJECTS } from '../constants/data';

const Projects = () => (
  <div className="min-h-screen bg-black pt-16 relative overflow-hidden">
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold text-white mb-4 font-mono">
          <span className="text-green-400">&gt;</span> SOLUTION.PORTFOLIO
        </h1>
        <p className="text-gray-400 font-mono max-w-3xl mx-auto">
          [ ENTERPRISE ENABLEMENT & TECHNICAL RESOURCES ]<br/>
          From POV frameworks to integration accelerators
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {PROJECTS.map((project) => (
          <ProjectCard key={project.title} project={project} />
        ))}
      </div>
    </div>
  </div>
);

export default Projects;